var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarAlertTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A2402A9E-23A8-4FA4-B105-158B9B621C3C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail",
    transform: "translate(-215.000000, -863.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(216.000000, 864.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Phantom"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.2,
    stroke: "#FF335C",
    cx: 16,
    cy: 16,
    r: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,7 C18.1568438,7 19.4999883,8.34314453 19.4999883,9.99998828 L19.4999883,9.99998828 L19.4999883,17.1458477 C20.420625,17.9698047 21,19.1672617 21,20.5 C21,22.9853008 18.9852656,25 16.5,25 C14.0147344,25 12,22.9853008 12,20.5 C12,19.1672617 12.579375,17.9698047 13.5000117,17.1458125 L13.5000117,17.1458125 L13.5000117,9.99998828 C13.5000117,8.34314453 14.8431562,7 16.5,7 Z M16.5000176,13.0000117 C16.0858008,13.0000117 15.7500117,13.3358008 15.7500117,13.7500176 L15.7500117,13.7500176 L15.7507654,18.3777589 C14.8764713,18.68642 14.25,19.5200499 14.25,20.5 C14.25,21.7426407 15.2573593,22.75 16.5,22.75 C17.7426407,22.75 18.75,21.7426407 18.75,20.5 C18.75,19.5204306 18.1240154,18.6870678 17.2502535,18.3781189 L17.2502535,18.3781189 L17.2500234,13.7500176 C17.2500234,13.3358008 16.9142344,13.0000117 16.5000176,13.0000117 Z",
    id: "Combined-Shape",
    fill: "#FF335C",
    mask: "url(#mask-2)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAlertTemperature);
export default __webpack_public_path__ + "static/media/avatar-alert-temperature.0d2e45c3bfe525c50651e51ffdb9d978.svg";
export { ForwardRef as ReactComponent };